/* eslint-disable react/react-in-jsx-scope */
// import { Image, Table } from "react-bootstrap";
import React from "react";
import { Card, Image } from "react-bootstrap";
import logo from "../../../assets/img/KTSG.png";
import { formatNumber } from "../../../redux/utils";
import { toWordsconver } from "../../../redux/api";
import "./style.css";

const Trailbalance = ({
  form = {},
  user = {},
  data = [],
  taxesApplied = [],
}) => {
  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  let totalAmount = data.reduce((a, b) => a + parseFloat(b.amount), 0);

  let totalTaxesAmount = taxesApplied.reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );

  let netAmount = parseFloat(totalAmount) - parseFloat(totalTaxesAmount);

  data.forEach((item) => {
    totalAmount += parseInt(item.amount || 0);
  });

  taxesApplied.forEach((tax) => {
    totalAmount -= parseInt(tax.amount || 0);
  });

  return (
    <Card style={{height: "150vh"}}>
      <div>
        {data.map((item, index) => {
          const pendingSignature = item.history
            ? item.history.find((a) => a.pv_status === "Pending")
            : null;
          const redivedSignature = item.history
            ? item.history.find((a) => a.pv_status === "Redived")
            : null;
          const checkedSignature = item.history
            ? item.history.find((a) => a.pv_status === "Checked")
            : null;
          const approvedSignature = item.history
            ? item.history.find((a) => a.pv_status === "Approved")
            : null;
          return (
            <div
              key={index}
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  margin: "auto",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Image
                  src={logo}
                  alt="logo"
                  style={{
                    width: 110,
                    height: 100,
                    marginLeft: -15,
                    marginTop: 20,
                  }}
                />
                <p
                  style={{
                    fontSize: 17,
                    // marginTop: 10,
                    fontWeight: "bold",
                    marginBottom: 0,
                    marginTop: 0,
                  }}
                >
                  KATSINA STATE GOVERNMENT
                </p>
                <p
                  style={{
                    fontSize: 20,
                    fontWeight: "bold",
                    marginBottom: 0,
                    marginTop: 0,
                  }}
                >
                  {" "}
                  MINISTRY OF FINANCE
                </p>
                <p
                  style={{
                    fontSize: 17,
                    fontWeight: "bold",
                    marginBottom: 0,
                    marginTop: 0,
                  }}
                >
                  {" "}
                  MINISTERIAL/DEPARTMENTAL PAYMENT VOUCHER
                </p>
              </div>
              <div
                style={{
                  width: "100%",
                  // pageBreakInside: "avoid",
                  paddingLeft: 20,
                  paddingRight: 20,
                  fontSize: 10,
                  display: "flex",
                  flexDirection: "row",
                  lineHeight: 1.5,
                }}
              >
                <div
                  style={{
                    width: "75%",
                    height: "76vh",
                    // paddingTop: 10,
                    borderRight: "1px solid #000",
                  }}
                >
                  <p
                    style={{
                      fontSize: 18,
                      fontWeight: "500",
                      width: "100%",
                      marginLeft: 300,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    PAYMENT VOUCHER
                  </p>
                  <p
                    style={{
                      fontWeight: "bold",
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    KTT.44
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    Organisation:{" "}
                    {item?.mda_name
                      ? item.mda_name
                      : "......................................................................................................"}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    Sub Organisation Name:{" "}
                    {item?.sub
                      ? item.sub
                      : "......................................................................................................"}{" "}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    {" "}
                    Sub Sub Organisation Name:{" "}
                    {item?.sub_sub
                      ? item.sub_sub
                      : "......................................................................................................"}{" "}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    Sub Sub Sub Organisation Name:{" "}
                    {item?.sub_sub_sub
                      ? item.sub_sub_sub
                      : "......................................................................................................"}
                  </p>
                  <p
                    style={{
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                    }}
                  >
                    Payment to:
                    {item?.payment_to
                      ? item.payment_to
                      : "................................................................................................................."}
                  </p>
                  <div>
                    <table className="invoice-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Detailed description of service</th>
                          <th>Rate</th>
                          <th colSpan="2">Amount(₦)</th>
                        </tr>
                        <tr style={{ width: "100%" }}>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th style={{ width: "15%" }}>₦</th>
                          <th style={{ width: "5%" }}>K</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style={{ width: "100%", height: "20vh" }}>
                          <td></td>
                          <td
                            style={{
                              pathAlign: "left",
                            }}
                          >
                            {capitalizeFirstLetter(item?.narration)}
                          </td>
                          <td></td>
                          <td style={{ pathAlign: "right" }}>
                            {formatNumber(item?.amount)?.split(".")[0]}
                          </td>
                          <td>
                            {item?.amount?.toString()?.split(".")[1] || "00"}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr style={{ width: "100%", height: "4vh" }}>
                          <td colSpan="2" style={{ pathAlign: "justify" }}>
                            TOTAL AMOUNT IN WORDS:
                            {toWordsconver(
                              netAmount.toString().split(".")[0]
                            )?.toUpperCase()}
                            NAIRA
                            {netAmount.toString().split(".")[1] &&
                            netAmount.toString().split(".")[1] !== "00"
                              ? ` AND ${toWordsconver(
                                  netAmount.toString().split(".")[1]
                                )?.toUpperCase()} KOBO`
                              : null}{" "}
                            ONLY
                          </td>
                          <td colSpan="2" style={{ pathAlign: "right" }}>
                            {formatNumber(netAmount)?.split(".")[0]}
                          </td>
                          <td>
                            {netAmount?.toString()?.split(".")[1] || "00"}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      borderBottom: "1px solid #000",
                      paddingLeft: 2,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      We certify that the details above are in accordance with
                      the relevant contract, regulations or other authority
                      under which the Services/Goods were provided/purchased
                    </p>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <p
                        style={{
                          width: "70%",
                          fontSize: 12,
                          marginBottom: 0,
                          marginTop: 0,
                        }}
                      >
                        Officer who prepared voucher, Signature:
                      </p>
                      {pendingSignature?.signature ? (
                        <Image
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          src={pendingSignature.signature}
                        />
                      ) : null}
                    </div>
                    <p
                      style={{
                        marginLeft: 53,
                        pathTransform: "uppercase",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Name (in block letters):
                      {pendingSignature?.fullname}
                    </p>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        // marginTop: -50,
                      }}
                    >
                      <p
                        style={{
                          width: "70%",
                          fontSize: 12,
                          marginBottom: 0,
                          marginTop: 0,
                        }}
                      >
                        Officer who checked voucher, Signature:
                      </p>
                      {checkedSignature?.signature ? (
                        <Image
                          style={{
                            width: 30,
                            height: 30,
                          }}
                          src={checkedSignature.signature}
                        />
                      ) : null}
                    </div>
                    <p
                      style={{
                        marginLeft: 53,
                        pathTransform: "uppercase",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Name (in block letters):{checkedSignature?.fullname}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      borderBottom: "1px solid #000",
                      paddingLeft: 2,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      We certify that the Service/Goods have been duly
                      performed/received, that financial authority
                      GW/.............. is held to incur this expenditure and
                      that the relevant D V.E account entries have been made. We
                      hereby authorized payment.
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    {" "}
                    <p
                      style={{
                        width: "30%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Signature:
                    </p>
                    {approvedSignature?.signature ? (
                      <Image
                        style={{
                          width: 30,
                          height: 30,
                        }}
                        src={approvedSignature.signature}
                      />
                    ) : null}
                  </div>
                  <p
                    style={{
                      width: "100%",
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                      // marginLeft: "55%",
                    }}
                  >
                    (Accounting Officer)
                  </p>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: 20,
                    }}
                  >
                    <p
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                        pathTransform: "uppercase",
                      }}
                    >
                      Name (in block letters):
                      {approvedSignature?.fullname}
                    </p>
                    <performance
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Date:
                      {item?.pv_date}
                    </performance>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        width: "30%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Signature:
                    </p>
                    {redivedSignature?.signature ? (
                      <Image
                        style={{
                          width: 30,
                          height: 30,
                        }}
                        src={redivedSignature.signature}
                      />
                    ) : null}
                  </div>
                  <p
                    style={{
                      width: "100%",
                      fontSize: 12,
                      marginBottom: 0,
                      marginTop: 0,
                      // marginLeft: "55%",
                    }}
                  >
                    (Accounting Officer)
                  </p>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      marginBottom: 20,
                    }}
                  >
                    <d
                      style={{
                        width: "50%",
                        pathTransform: "uppercase",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Name (in block letters):
                      {redivedSignature?.fullname}
                    </d>
                    <p
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Date:
                      {item?.pv_date}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      borderBottom: "1px solid #000",
                      borderTop: "1px solid #000",
                      paddingLeft: 2,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <p
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Cheque No:
                    </p>
                    <p
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Account No:
                      {item?.contractor_acc_no}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      borderBottom: 1,
                      paddingLeft: 2,
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    <p
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Account Name:
                      {item?.contractor_acc_name}
                    </p>
                    <p
                      style={{
                        width: "50%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      {" "}
                      Name of Bank:
                      {item?.contractor_bank_name}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      paddingLeft: 2,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Received the sum of .....................................
                      Naira and......................................Kobo in
                    </p>
                    <p
                      style={{
                        width: "100%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      acquisition of the above Account
                      this.............................Day
                      of..........................20..........
                    </p>
                    <p
                      style={{
                        width: "100%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Amount in word.....................................Name of
                      Payee...................................................
                    </p>
                    <p
                      style={{
                        width: "100%",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Witness in official
                      Name..........................................Rank.................................................
                    </p>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "60%",
                        marginLeft: 40,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <p
                          style={{
                            fontSize: 12,
                            marginBottom: 0,
                            marginTop: 0,
                          }}
                        >
                          Witness
                        </p>
                        <p
                          style={{
                            fontSize: 12,
                            marginBottom: 0,
                            marginTop: 0,
                          }}
                        >
                          Official
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: 40,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 12,
                            marginBottom: 0,
                            marginTop: 0,
                          }}
                        >
                          Name.......................................
                        </p>
                        <p
                          style={{
                            fontSize: 12,
                            marginBottom: 0,
                            marginTop: 0,
                          }}
                        >
                          Rank........................................
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ width: "30%", paddingLeft: 20, paddingTop: 10 }}>
                  <div
                    style={{
                      width: "100%",
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                      }}
                    >
                      Voucher Number
                    </p>
                    <div
                      style={{
                        width: "100%",
                        border: "1px solid #000",
                        display: "flex",
                        flexDirection: "row",
                        height: 24,
                      }}
                    >
                      {String(item?.pv_code)
                        .split("")
                        .map((digit, index) => (
                          <p
                            key={index}
                            style={{
                              width: "33.3%",
                              height: 22,
                              textAlign: "center",
                              fontSize: 12,
                              marginBottom: 0,
                              marginTop: 0,
                              borderRight:
                                index < String(item?.pv_code).length - 1
                                  ? "1px solid #000"
                                  : 0,
                              //   paddingTop: 3,
                            }}
                          >
                            {digit}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 30,
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 0,
                        marginTop: 0,
                        fontSize: 12,
                      }}
                    >
                      Date/Month/Year
                    </p>
                    <div
                      style={{
                        width: "100%",
                        height: 24,
                        border: "1px solid #000",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {String(item?.date)
                        .split("")
                        .map((digit, index) => (
                          <p
                            key={index}
                            style={{
                              width: "12.5%",
                              height: 22,
                              textAlign: "center",
                              fontSize: 12,
                              marginBottom: 0,
                              marginTop: 0,
                              borderRight:
                                index < String(item?.date).length - 1
                                  ? "1px solid #000"
                                  : 0,
                              paddingTop: 3,
                            }}
                          >
                            {digit}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 30,
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 0,
                        marginTop: 0,
                        fontSize: 12,
                      }}
                    >
                      Administrative Code
                    </p>
                    <div
                      style={{
                        width: "100%",
                        height: 24,
                        border: "1px solid #000",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      {String(item?.mda_code)
                        .split("")
                        .map((digit, index) => (
                          <p
                            key={index}
                            style={{
                              width: "8.3%",
                              textAlign: "center",
                              height: 22,
                              fontSize: 12,
                              marginBottom: 0,
                              marginTop: 0,
                              borderRight:
                                index < String(item?.mda_code).length - 1
                                  ? "1px solid #000"
                                  : 0,
                              paddingTop: 3,
                            }}
                          >
                            {digit}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 30,
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 0,
                        marginTop: 0,
                        fontSize: 12,
                      }}
                    >
                      Economic Code
                    </p>
                    <div
                      style={{
                        width: "100%",
                        border: "1px solid #000",
                        display: "flex",
                        flexDirection: "row",
                        height: 24,
                        textAlign: "center",
                      }}
                    >
                      {String(item?.economic_code)
                        .split("")
                        .map((digit, index) => (
                          <p
                            key={index}
                            style={{
                              width: "12.5%",
                              height: 22,
                              fontSize: 12,
                              marginBottom: 0,
                              marginTop: 0,
                              textAlign: "center",
                              borderRight:
                                index < String(item?.economic_code).length - 1
                                  ? "1px solid #000"
                                  : 0,
                              paddingTop: 3,
                            }}
                          >
                            {digit}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 30,
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 0,
                        marginTop: 0,
                        fontSize: 12,
                      }}
                    >
                      Program Code
                    </p>
                    <p
                      style={{
                        width: "100%",
                        border: "1px solid #000",
                        display: "flex",
                        flexDirection: "row",
                        height: 24,
                        fontSize: 12,
                        marginBottom: 0,
                        marginTop: 0,
                        textAlign: "center",
                      }}
                    >
                      {item?.program_code &&
                        String(item?.program_code)
                          .split("")
                          .map((digit, index) => (
                            <p
                              key={index}
                              style={{
                                width: "12.5%",
                                height: 22,
                                textAlign: "center",
                                borderRight:
                                  index < String(item?.program_code).length - 1
                                    ? "1px solid #000"
                                    : 0,
                                paddingTop: 3,
                              }}
                            >
                              {digit}
                            </p>
                          ))}
                    </p>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 30,
                    }}
                  >
                    <p
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginBottom: 0,
                        marginTop: 0,
                        fontSize: 12,
                      }}
                    >
                      Functional Code
                    </p>
                    <div
                      style={{
                        width: "100%",
                        border: "1px solid #000",
                        display: "flex",
                        flexDirection: "row",
                        height: 24,
                        textAlign: "center",
                      }}
                    >
                      {String(item?.funtional_code)
                        .split("")
                        .map((digit, index) => (
                          <p
                            key={index}
                            style={{
                              width: "100%",
                              textAlign: "center",
                              height: 22,
                              fontSize: 12,
                              marginBottom: 0,
                              marginTop: 0,
                              borderRight:
                                index < String(item?.funtional_code).length - 1
                                  ? "1px solid #000"
                                  : 0,
                              paddingTop: 20,
                            }}
                          >
                            {/* {digit} */}
                          </p>
                        ))}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      marginTop: 50,
                    }}
                  >
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      Date received in Treasury{" "}
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      ............................................
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      Check and passed at{" "}
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      ............................................
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      For{" "}
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      Payable only at{" "}
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      Checked by internal Auditor
                    </p>
                    <p style={{ fontSize: 12, marginBottom: 0, marginTop: 0 }}>
                      (Name and Signature)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default Trailbalance;
